"use client";

import ViuGoOddsMatchCell from "./ViuGoOddsMatchCell";
import ViuGoOddsMatchOuCell from "./ViuGoOddsMatchOuCell";
import ViuGoOddsMatch1x2Cell from "./ViuGoOddsMatch1x2Cell";

export default function ViuGoOddsColumn({
    handicapLabel,
    homeHandicap,
    homeHandicapTrend,
    awayHandicap,
    awayHandicapTrend,
    overUnderLine,
    overOdds,
    overTrend,
    underOdds,
    underTrend,
    oneX2Home,
    oneX2HomeTrend,
    oneX2Draw,
    oneX2DrawTrend,
    oneX2Away,
    oneX2AwayTrend,
}) {
    return (
        <div className="flex w-[35%] flex-col items-center justify-center [border-bottom:1px_solid_var(--theme-border)]">
            <div className="flex h-full w-full flex-row px-[3px] py-2 text-center">
                <div className="flex w-1/3 flex-col justify-start gap-1 px-1 py-2 font-bold">
                    <ViuGoOddsMatchCell
                        label={handicapLabel}
                        value={homeHandicap}
                        trend={homeHandicapTrend}
                    />
                    <ViuGoOddsMatchCell
                        label=""
                        value={awayHandicap}
                        trend={awayHandicapTrend}
                    />
                </div>

                <div className="flex w-1/3 flex-col justify-start gap-1 px-1 py-2 font-bold">
                    <ViuGoOddsMatchOuCell
                        line={overUnderLine}
                        side="O"
                        odds={overOdds}
                        trend={overTrend}
                    />
                    <ViuGoOddsMatchOuCell
                        line={overUnderLine}
                        side="U"
                        odds={underOdds}
                        trend={underTrend}
                    />
                </div>

                <div className="flex w-1/3 flex-col justify-start gap-1 px-1 py-2 font-bold">
                    <ViuGoOddsMatch1x2Cell value={oneX2Home} trend={oneX2HomeTrend} />
                    <ViuGoOddsMatch1x2Cell value={oneX2Draw} trend={oneX2DrawTrend} />
                    <ViuGoOddsMatch1x2Cell value={oneX2Away} trend={oneX2AwayTrend} />
                </div>
            </div>
        </div>
    );
}
